module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sky-sticky', {
      sticky: _vm.sticky
    }],
    style: ({
      height: _vm.contentDimensions.height
    })
  }, [_c('div', {
    ref: "stickyContent",
    staticClass: "sticky-content",
    style: ({
      width: _vm.contentDimensions.width
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-647504a8"}!./scripts/sky-sticky/sky-sticky.html
// module id = 373
// module chunks = 1